import { useAppSelector } from 'store/hook';
import Loader from './Loader';

const CommonLoader = () => {
    const loading = useAppSelector((state) => state.ui.isCommonLoading);
    return <div className="z-30 fixed top-28 right-10">{loading && <Loader size={8} />}</div>;
};

export default CommonLoader;
